<template>
  <div
    class="toast-container"
    v-if="store.isOpen()"
  >
    <div
      class="toast"
      :[store.color]="Boolean(store.color)"
    >
      <p v-text="store.text" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { snackbarStore } from '@/store/app';
const store = snackbarStore();
</script>
<style lang="scss" scoped>
.toast-container {
  position: relative;
  width: 100%;

  &>.toast {
    position: absolute;
    z-index: 199;
    right: 0;
    top: 48px;
    padding: 0 16px;
    border-radius: 4px;
    background-color: var(--primary);

    &[success="true"] {
      background-color: var(--success);
    }

    &[warning="true"] {
      background-color: var(--warning);
    }

    &[error="true"] {
      background-color: var(--error);
    }

    p {
      font-size: 0.9rem;
      color: white;
    }
  }
}
</style>
